var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.058 2.73c5.431-.24 8.456-.24 13.888 0h.002c1.842 0 3.34 1.538 3.34 3.458v.004c.22 3.086.214 8.524-.005 11.602v.004c0 1.92-1.498 3.47-3.34 3.47h-.002M5.058 2.73 18.94 21.268M5.058 2.73h0-.003c-1.837 0-3.334 1.546-3.334 3.467V6.2s0 0 0 0c-.23 3.073-.225 8.512-.005 11.594v.004c0 1.92 1.498 3.47 3.335 3.47h.002s0 0 0 0M5.058 2.73l.033.75-.038 17.788m13.888 0h0m0 0s0 0 0 0m0 0H5.053m13.888 0c-5.443.247-8.445.238-13.888 0m4.843-6.863a.75.75 0 0 0 1.182.614l3.421-2.407a.75.75 0 0 0 0-1.227L11.077 8.98a.75.75 0 0 0-1.18.614v4.811Zm12.491-8.242.002.048c.218 3.087.213 8.485-.005 11.564a.76.76 0 0 0-.001.047c-.013 1.955-1.538 3.538-3.424 3.546h-.03c-5.43.247-8.434.238-13.864 0h-.03c-1.88-.008-3.406-1.59-3.419-3.546 0-.016 0-.031-.002-.047-.217-3.082-.222-8.48.005-11.554a.756.756 0 0 0 .002-.05c.013-1.954 1.538-3.532 3.42-3.54l.029-.001c5.418-.24 8.445-.24 13.863 0h.03c1.886.009 3.411 1.579 3.424 3.533ZM9.823 8.01a.05.05 0 0 1 .052.003l5.613 3.945a.05.05 0 0 1 0 .082l-5.613 3.947a.05.05 0 0 1-.079-.041V8.054a.05.05 0 0 1 .027-.044Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLine);
export default __webpack_public_path__ + "static/media/youtube_line.c43fcb15c1c2f9b3b2fe975cb1b001d0.svg";
export { ForwardRef as ReactComponent };